import type { ModuleVM, DescriptorVM } from "@/types/view";

export function forEachStatement(
  t: ModuleVM,
  visitor: (stmt: any, ctx: { descriptor: DescriptorVM | null }) => boolean | void
): void {
  // If your TemplateVM ever gains root-level statements, handle them here
  if ((t as any).statements?.length) {
    for (const s of (t as any).statements) {
      if (visitor(s, { descriptor: null }) === true) return;
    }
  }
  for (const d of t.descriptors ?? []) {
    if (visitDescriptor(d, visitor) === true) return;
  }
}

function visitDescriptor(
  d: DescriptorVM,
  visitor: (stmt: any, ctx: { descriptor: DescriptorVM | null }) => boolean | void
): boolean {
  for (const s of (d.statements ?? [])) {
    if (visitor(s, { descriptor: d }) === true) return true;
  }
  for (const c of d.descriptors ?? []) {
    if (visitDescriptor(c, visitor) === true) return true;
  }
  return false;
}
